import React from "react";
import "./Betting_Rebate_History.css";
import Betting_Rebate_history_card from "../Betting_Rebate/Betting_Rebate_history_card/Betting_Rebate_history_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";

function Betting_Rebate_History() {
  return (
    <>
      <section className="Betting_Rebate_History">
        <Common_white_header headingText={"Betting Rebate History"} />

        <div className="container">
          <Betting_Rebate_history_card />
          <Betting_Rebate_history_card />
          <Betting_Rebate_history_card />
          <Betting_Rebate_history_card />
          <Betting_Rebate_history_card />
          <Betting_Rebate_history_card />
        </div>
      </section>
    </>
  );
}

export default Betting_Rebate_History;
